import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 9"
}, t = /* @__PURE__ */ e("path", {
  fill: "#141B34",
  "fill-rule": "evenodd",
  d: "M4.832 8.5a.5.5 0 0 0 .5.5h3a3.5 3.5 0 0 0 0-7h-7a.5.5 0 0 0 0 1h7a2.5 2.5 0 0 1 0 5h-3a.5.5 0 0 0-.5.5",
  "clip-rule": "evenodd"
}, null, -1), d = /* @__PURE__ */ e("path", {
  fill: "#141B34",
  "fill-rule": "evenodd",
  d: "M3.02 4.854a.5.5 0 0 0 0-.708L1.492 2.618 1.375 2.5l.117-.118L3.02.854a.5.5 0 0 0-.707-.708L.784 1.675l-.016.016c-.097.097-.201.201-.277.302a.83.83 0 0 0-.186.507c0 .222.096.39.186.507.076.1.18.205.277.302l.016.016 1.53 1.529a.5.5 0 0 0 .706 0",
  "clip-rule": "evenodd"
}, null, -1), c = [
  t,
  d
];
function a(r, i) {
  return l(), o("svg", n, [...c]);
}
const h = { render: a };
export {
  h as default,
  a as render
};
